var text = function (text, fontSize, max) {
    var _max = max || text.length;
    return Math.min(1, _max / text.length) * fontSize;
};
var UtilsScale = {
    text: text,
};
export default UtilsScale;
